export default {
      id: "flex-justifyContent-space-evenly-usage",
      viewBox: "0 0 40 40",
      url: "assets/" + "sprite.svg#flex-justifyContent-space-evenly-usage",
      toString: function () {
        return this.url;
      }
    }